export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Download a JPG image',
    downloadPDF: 'Download a PDF document',
    downloadPNG: 'Download a PNG image',
    downloadSVG: 'Download an SVG image',
    exportButtonTitle: 'Export',
    forexRate: 'Average FOREX rate',
    loading: 'Loading...',
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    printButtonTitle: 'Print',
    rangeSelectorFrom: 'From',
    rangeSelectorTo: 'To',
    rangeSelectorZoom: 'Zoom',
    rateTypes: {
      ask: 'The best sale offer',
      bid: 'The best buy offer',
      forex: 'Average exchange rate in the world',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    thousandsSep: ' ',
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    wtBestAsk: 'The best sale offer',
    wtBestBid: 'The best buy offer',
    seriesError: 'At least one option must be selected',
  },
  calculator: {
    title: 'Calculate savings in Walutomat',
    forBuy: 'for',
    unsupportedPair: 'We currently do not offer rates for the selected currency pair.',
    spinnerError: {
      generic: 'There was a problem with downloading data',
      toManyRequests:
        'The calculator is currently unavailable. Please try again later or contact <a href="https://www.walutomat.com/en/contact/">Customer Service</a>.',
    },
    commissionWT: 'Walutomat commission',
    ctaButton: 'Exchange',
    amountText: 'Amount',
    minAmount: 'The minimum exchange amount is {{amount}} {{currency}}.',
    genericMinAmount: 'The exchange amount is too low.',
  },
  transferCalculator: {
    exchangeRates: 'Exchange rate',
    details: 'Details',
    amountYouSend: 'Amount you send',
    countryYouSendMoney: 'Country you’re sending money to',
    foreignTransferFee: 'Foreign transfer fee',
    foreignTransferType: 'Foreign transfer type',
    exchangeAmount: 'Exchange amount',
    amountRecipientReceive: 'Amount the recipient receives',
    notSellCurrency: 'Currency sale is unavailable.',
    noCurrenciesSupportedInfo: 'Currency pair not supported',
    noCountrySupportedInfo: 'We do not support the selected pair in the chosen country.',
    amountTooLowForFees: 'The entered amount is too low — after all fees the recipient would receive nothing.',
    enterAmount: 'Enter amount',
    commissionWT: 'Walutomat commission',
    equivalentFee: 'Equivalent',
    commissionAmount: '{{fee_percent}}% of the total amount',
    ctaButton: 'Send money',
  },
  timer: {
    update: 'Refreshing in:',
    timeUnit: 'sec.',
  },
  networkErrorStatus: {
    slow: 'Problem retrieving exchange rates. Slow internet connection',
    noNetwork: 'Problem retrieving exchange rates. Check your internet connection',
    default: 'Technical issues occurred. Please contact customer support',
  },
  transferTypes: {
    elixir: {
      header: 'Standard',
      subtext: 'The money will arrive within 2 - 3 working days.',
      subtextNoAdditionalCosts:
        'When transferring {{currency}} to {{country}} banks usually do not charge any additional transfer fees.',
      subtextPayoutInPoland: 'Banks usually do not collect any additional transfer fees for transfers in Poland.',
      subtextSelf: 'The money will arrive within 2 - 3 working days.',
      subtextWarning:
        'Important: banks may charge an additional fee which depends on the currency and the destination country.',
    },
    internal: {
      header: 'Standard',
      subtext: 'The money will arrive on the next working day at the latest.',
      subtextNoAdditionalCosts:
        'For transfer of {{currency}} {{country}} banks usually do not collect any additional fees for the transfer.',
      subtextPayoutInPoland: 'Banks usually do not collect any additional fees for transfers in Poland.',
      subtextSelf: 'The money will arrive on the next working day at the latest.',
      subtextWarning:
        'Important: banks may charge an additional fee which depends on the currency and the destination country.',
    },
    internal_bre: {
      header: 'Standard',
      subtext: 'The money will arrive within 2 - 3 working days.',
      subtextNoAdditionalCosts:
        'For transfer of {{currency}} {{country}} banks usually do not collect any additional fees for the transfer.',
      subtextPayoutInPoland: 'Banks usually do not collect any additional fees for transfers in Poland.',
      subtextSelf: 'The money will arrive within 2 - 3 working days.',
      subtextWarning:
        'Important: banks may charge an additional fee which depends on the currency and the destination country.',
    },
    sepa: {
      header: 'Standard',
      subtext: 'The money will arrive within 1 - 2 working days.',
      subtextNoAdditionalCosts:
        'For transfer of {{currency}} {{country}} banks usually do not collect any additional fees for the transfer.',
      subtextPayoutInPoland: 'Banks usually do not collect any additional fees for transfers in Poland.',
      subtextSelf: 'The money will arrive within 1 - 2 working days.',
      subtextWarning:
        'Important: banks may charge an additional fee which depends on the currency and the destination country.',
    },
    sorbnet: {
      header: 'Express transfer',
      subtext: 'The money will arrive on the next working day at the latest.',
      subtextNoAdditionalCosts:
        'For transfer of {{currency}} {{country}} banks usually do not collect any additional fees for the transfer.',
      subtextPayoutInPoland: 'Banks usually do not collect any additional fees for transfers in Poland.',
      subtextSelf: 'The money will arrive on the next working day at the latest.',
      subtextWarning:
        'Important: banks may charge an additional fee which depends on the currency and the destination country.',
    },
    spot: {
      header: 'Standard',
      subtext: 'The money will arrive within 2 - 3 working days.',
      subtextNoAdditionalCosts:
        'For transfer of {{currency}} {{country}} banks usually do not collect any additional fees for the transfer.',
      subtextPayoutInPoland: 'Banks usually do not collect any additional fees for transfers in Poland.',
      subtextSelf: 'The money will arrive within 2 - 3 working days.',
      subtextWarning:
        'Important: banks may charge an additional fee which depends on the currency and the destination country.',
    },
    'swift usd': {
      header: 'Standard',
      subtext: 'The money will arrive within 2 - 3 working days.',
      subtextNoAdditionalCosts:
        'For transfer of {{currency}} {{country}} banks usually do not collect any additional fees for the transfer.',
      subtextPayoutInPoland: 'Banks usually do not collect any additional fees for transfers in Poland.',
      subtextSelf: 'The money will arrive within 2 - 3 working days.',
      subtextWarning:
        'Important: banks may charge an additional fee which depends on the currency and the destination country.',
    },
    today: {
      header: 'Express transfer',
      subtext: 'The money will arrive on the next working day at the latest.',
      subtextNoAdditionalCosts:
        'For transfer of {{currency}} {{country}} banks usually do not collect any additional fees for the transfer.',
      subtextPayoutInPoland: 'Banks usually do not collect any additional fees for transfers in Poland.',
      subtextSelf: 'The money will arrive on the next working day at the latest.',
      subtextWarning:
        'Important: banks may charge an additional fee which depends on the currency and the destination country.',
    },
    today_our: {
      header: 'Express transfer (OUR)',
      subtext:
        'The money will arrive on the next working day at the latest. A guarantee that the recipient will receive the full amount and the banks will not charge any additional fees along the way.',
      subtextNoAdditionalCosts: '',
      subtextPayoutInPoland: '',
      subtextSelf:
        'Money will be received on the next business day at the latest. The warranty that the You will receive the entire amount and the banks will not collect any additional fees on the way.',
      subtextWarning: '',
    },
    sepa_instant: {
      header: 'Instant',
      subtext: 'The money will arrive in about 1 minute.',
      subtextNoAdditionalCosts: '',
      subtextPayoutInPoland: '',
      subtextSelf: 'The money will arrive in about 1 minute.',
      subtextWarning: 'Instant transfers are limited to {{maxAmount}}.',
    },
    local: {
      header: 'Express transfer',
      subtext: 'The money will arrive on the next working day at the latest.',
      subtextNoAdditionalCosts: '',
      subtextPayoutInPoland: '',
      subtextSelf: 'The money will arrive on the next working day at the latest.',
      subtextWarning: '',
    },
    local_express: {
      header: 'Instant',
      subtext: 'The money will arrive in about 30 minutes, no later than the next business day.',
      subtextNoAdditionalCosts: '',
      subtextPayoutInPoland: '',
      subtextSelf: 'The money will arrive in about 30 minutes, no later than the next business day.',
      subtextWarning: 'Instant transfers are limited to {{maxAmount}}.',
    },
  },
  countries: {
    AD: 'Andorra',
    AE: 'United Arab Emirates',
    AF: 'Afghanistan',
    AG: 'Antigua and Barbuda',
    AI: 'Anguilla',
    AL: 'Albania',
    AM: 'Armenia',
    AN: 'Netherlands Antilles',
    AO: 'Angola',
    AQ: 'Antarctica',
    AR: 'Argentina',
    AS: 'American Samoa',
    AT: 'Austria',
    AU: 'Australia',
    AW: 'Aruba',
    AX: 'Åland Islands',
    AZ: 'Azerbaijan',
    BA: 'Bosnia and Herzegovina',
    BB: 'Barbados',
    BD: 'Bangladesh',
    BE: 'Belgium',
    BF: 'Burkina Faso',
    BG: 'Bulgaria',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'Saint-Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei Darussalam',
    BO: 'Bolivia',
    BQ: 'Bonaire',
    BR: 'Brazil',
    BS: 'Bahamas',
    BT: 'Bhutan',
    BV: 'Bouvet Island',
    BW: 'Botswana',
    BY: 'Belarus',
    BZ: 'Belize',
    CA: 'Canada',
    CC: 'Cocos Islands',
    CD: 'Democratic Republic of the Congo',
    CF: 'Central African Republic',
    CG: 'Congo',
    CH: 'Switzerland',
    CI: "Côte d'Ivoire",
    CK: 'Cook Islands',
    CL: 'Chile',
    CM: 'Cameroon',
    CN: 'China',
    CO: 'Colombia',
    CR: 'Costa Rica',
    CU: 'Cuba',
    CV: 'Cabo Verde',
    CW: 'Curaçao',
    CX: 'Christmas Island',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DE: 'Germany',
    DJ: 'Djibouti',
    DK: 'Denmark',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    DZ: 'Algeria',
    EC: 'Ecuador',
    EE: 'Estonia',
    EG: 'Egypt',
    EH: 'Western Sahara',
    ER: 'Eritrea',
    ES: 'Spain',
    ET: 'Ethiopia',
    FI: 'Finland',
    FJ: 'Fiji',
    FK: 'Falkland Islands',
    FM: 'Micronesia',
    FO: 'Faroe Islands',
    FR: 'France',
    GA: 'Gabon',
    GB: 'United Kingdom',
    GD: 'Grenada',
    GE: 'Georgia',
    GF: 'French Guiana',
    GG: 'Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Greenland',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Equatorial Guinea',
    GR: 'Greece',
    GS: 'South Georgia and the South Sandwich Islands',
    GT: 'Guatemala',
    GU: 'Guam',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HK: 'Hong Kong',
    HM: "Heard and McDonald's Islands",
    HN: 'Honduras',
    HR: 'Croatia',
    HT: 'Haiti',
    HU: 'Hungary',
    ID: 'Indonesia',
    IE: 'Ireland',
    IL: 'Israel',
    IM: 'Isle of Man',
    IN: 'India',
    IO: 'British Indian Ocean Territory',
    IQ: 'Iraq',
    IR: 'Iran',
    IS: 'Iceland',
    IT: 'Italy',
    JE: 'Jersey',
    JM: 'Jamaica',
    JO: 'Jordan',
    JP: 'Japan',
    KE: 'Kenya',
    KG: 'Kyrgyzstan',
    KH: 'Cambodia',
    KI: 'Kiribati',
    KM: 'Comoro Islands',
    KN: 'Saint Kitts and Nevis',
    KP: 'North Korea',
    KR: 'South Korea',
    KW: 'Kuwait',
    KY: 'Cayman Islands',
    KZ: 'Kazakhstan',
    LA: 'Laos',
    LB: 'Lebanon',
    LC: 'Saint Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    LV: 'Latvia',
    LY: 'Libya',
    MA: 'Morocco',
    MC: 'Monaco',
    MD: 'Moldova',
    ME: 'Montenegro',
    MF: 'Saint-Martin',
    MG: 'Madagascar',
    MH: 'Marshall Islands',
    MK: 'North Macedonia',
    ML: 'Mali',
    MM: 'Myanmar',
    MN: 'Mongolia',
    MO: 'Macau',
    MP: 'Northern Mariana Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Maldives',
    MW: 'Malawi',
    MX: 'Mexico',
    MY: 'Malaysia',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NC: 'New Caledonia',
    NE: 'Niger',
    NF: 'Norfolk',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Netherlands',
    NO: 'Norway',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'New Zealand',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'French Polynesia',
    PG: 'Papua New Guinea',
    PH: 'Philippines',
    PK: 'Pakistan',
    PL: 'Poland',
    PM: 'Saint-Pierre and Miquelon',
    PN: 'Pitcairn',
    PR: 'Puerto Rico',
    PS: 'Palestine',
    PT: 'Portugal',
    PW: 'Palau',
    PY: 'Paraguay',
    QA: 'Qatar',
    RE: 'Reunion',
    RO: 'Romania',
    RS: 'Serbia',
    RU: 'Russia',
    RW: 'Rwanda',
    SA: 'Saudi Arabia',
    SB: 'Solomon Islands',
    SC: 'Seychelles',
    SD: 'Sudan',
    SE: 'Sweden',
    SG: 'Singapore',
    SH: 'Saint Helena, Ascension and Tristan da Cunha',
    SI: 'Slovenia',
    SJ: 'Svalbard and Jan Mayen',
    SK: 'Slovakia',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Suriname',
    SS: 'South Sudan',
    ST: 'São Tomé and Príncipe',
    SV: 'El Salvador',
    SX: 'Sint Maarten',
    SY: 'Syria',
    SZ: 'Eswatini',
    TC: 'Turks and Caicos Islands',
    TD: 'Chad',
    TF: 'French Southern and Antarctic Lands',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tajikistan',
    TK: 'Tokelau',
    TL: 'Timor-Leste',
    TM: 'Turkmenistan',
    TN: 'Tunisia',
    TO: 'Tonga',
    TR: 'Turkey',
    TT: 'Trinidad and Tobago',
    TV: 'Tuvalu',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    UA: 'Ukraine',
    UG: 'Uganda',
    UM: 'United States Minor Outlying Islands',
    US: 'United States',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VA: 'Vatican',
    VC: 'Saint Vincent and the Grenadines',
    VE: 'Venezuela',
    VG: 'British Virgin Islands',
    VI: 'United States Virgin Islands',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis and Futuna',
    WS: 'Samoa',
    XK: 'Kosovo',
    YE: 'Yemen',
    YT: 'Mayotte',
    ZA: 'South Africa',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
  },
  currencies: {
    ALL: 'All currencies',
    BGN: 'Bulgarian lev',
    CHF: 'Swiss franc',
    CZK: 'Czech koruna',
    DKK: 'Danish krone',
    EUR: 'Euro',
    GBP: 'Pound sterling',
    NOK: 'Norwegian krone',
    PLN: 'Polish zloty',
    RON: 'Romanian leu',
    SEK: 'Swedish krona',
    USD: 'US dollar',
    ZAR: 'South African rand',
    TRY: 'Turkish lira',
    SGD: 'Singapore dollar',
    RUB: 'Russian ruble',
    NZD: 'New Zealand dollar',
    MXN: 'Mexican peso',
    HKD: 'Hong Kong dollar',
    CAD: 'Canadian dollar',
    AUD: 'Australian dollar',
    HUF: 'Hungarian forint',
    CNY: 'Chinese yuan',
    ILS: 'Israeli new shekel',
    JPY: 'Japanese yen',
    ARS: 'Argentine peso',
    BRL: 'Brazilian real',
    CLP: 'Chilean peso',
    COP: 'Colombian peso',
    UYU: 'Uruguayan peso',
    PEN: 'Peruvian sol',
    AED: 'UAE dirham',
    BDT: 'Bangladeshi taka',
    EGP: 'Egyptian pound',
    FJD: 'Fijian dollar',
    GHS: 'Ghanaian cedi',
    INR: 'Indian rupee',
    JOD: 'Jordanian dinar',
    KWD: 'Kuwaiti dinar',
    LSL: 'Lesotho loti',
    MAD: 'Moroccan dirham',
    NAD: 'Namibian dollar',
    NPR: 'Nepalese rupee',
    OMR: 'Omani rial',
    PGK: 'Papua New Guinea kina',
    PKR: 'Pakistani rupee',
    SAR: 'Saudi riyal',
    SZL: 'Swazi lilangeni',
    THB: 'Thai baht',
    WST: 'Samoan tala',
    allCurrenciesLabel: 'All',
    mainCurrenciesLabel: 'Major currencies:',
    restCurrenciesLabel: 'Remaining:',
    converted: {
      BGN: 'Bulgarian lev',
      CHF: 'Swiss franc',
      CZK: 'Czech koruna',
      DKK: 'Danish krone',
      EUR: 'Euro',
      GBP: 'Pound sterling',
      NOK: 'Norwegian krone',
      PLN: 'Polish zloty',
      RON: 'Romanian leu',
      SEK: 'Swedish krona',
      USD: 'US dollar',
      ZAR: 'South African rand',
      TRY: 'Turkish lira',
      SGD: 'Singapore dollar',
      RUB: 'Russian ruble',
      NZD: 'New Zealand dollar',
      MXN: 'Mexican peso',
      HKD: 'Hong Kong dollar',
      CAD: 'Canadian dollar',
      AUD: 'Australian dollar',
      HUF: 'Hungarian forint',
      ARS: 'Argentine peso',
      BRL: 'Brazilian real',
      CLP: 'Chilean peso',
      COP: 'Colombian peso',
      UYU: 'Uruguayan peso',
      PEN: 'Peruvian sol',
      AED: 'UAE dirham',
      BDT: 'Bangladeshi taka',
      CNY: 'Chinese yuan',
      EGP: 'Egyptian pound',
      FJD: 'Fijian dollar',
      GHS: 'Ghanaian cedi',
      INR: 'Indian rupee',
      JOD: 'Jordanian dinar',
      KWD: 'Kuwaiti dinar',
      LSL: 'Lesotho loti',
      MAD: 'Moroccan dirham',
      NAD: 'Namibian dollar',
      NPR: 'Nepalese rupee',
      OMR: 'Omani rial',
      PGK: 'Papua New Guinea kina',
      PKR: 'Pakistani rupee',
      SAR: 'Saudi riyal',
      SZL: 'Swazi lilangeni',
      THB: 'Thai baht',
      WST: 'Samoan tala',
    },
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  preactSelect: {
    search: 'Search...',
    searchNoResults: 'No results found',
  },
  widgetCalculator: {
    title: 'Check rates and{{nbsp}}exchange currency in{{nbsp}}Walutomat – quickly and{{nbsp}}conveniently.',
    actualRate: 'Current exchange rate',
    buySelect: 'Buy',
    sellSelect: 'Sell',
    exchangeAmountSellLabel: 'You will receive',
    exchangeAmountBuyLabel: 'Deposit',
    commission: 'Promotional commission ({{commission}}%)',
  },
  formValidation: {
    emptyField: 'The field cannot be empty',
    requiredField: 'The field is required',
    requireAllFields: 'All fields must be completed',
    passwordToShort: 'The password must be 8 characters long',
    emailNotValid: 'The field must contain a valid email address',
    emailReserved: 'The email address is already taken',
    emailUnregistered: 'The email address was not found in our customer database.',
    markField: 'Select at least one of the checkboxes',
    serverUnknownError: 'Server communication error',
    invalidCharacters: 'Field contains invalid characters',
    phoneNotValid: 'The phone number is incorrect',
    checkBoxBelow: 'Please tick the box below to send a message',
    promocodeInvalid: 'Invalid promotion code',
    newsletterAlreadySubscribed: 'This email is already subscribed to the newsletter.',
    captchaError: 'Verification failed. Please try again.',
  },
  password: {
    show: 'show',
    hide: 'hide',
  },
  howItWorks: {
    showButton: 'Show more',
    hideButton: 'Show less',
  },
  rateCalculator: {
    baseInputLabel: 'I have',
    counterInputLabel: 'I will receive',
    counterInputTooltip: 'Includes {{commission}}% commission',
    ctaAlert: 'Set currency alert',
  },
  esim: {
    searchPlaceholder: 'Search for a country or region...',
    searchAriaLabel: 'Search for a country or region',
    searchMinChars: 'Enter <b>at least 3 characters</b> to see results.',
    searchNoResults: '<b>No results found.</b> We could not find the country you searched for.',
    searchError: '<b>Something went wrong.</b> Failed to load the offer list.',
  },
  trackingEvent: {
    buttonGooglePlay: 'Download from Google Play',
    buttonAppStore: 'Download from the App Store',
  },
}
